module.exports = __webpack_public_path__ + "media/categories/2027-9151f03e.svg";